export const TEST_ID = {
  pageContainer: 'pageContainer',
  downloadAllButton: 'downloadAllButton',
  notFoundMessage: 'notFoundMessage',
};
